import styled from "styled-components";
import { Color } from "config/colors";

type DrawerProps = {
  open: boolean;
};

export const DrawerStyled = styled.div<DrawerProps>`
  position: fixed;
  display: flex;
  flex-direction: column;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: ${Color.White};
  border-right: 1px solid ${Color.SeaBlue200};
  ${(props) => !props.open && "display: none"};
  z-index: 100;

  @media (min-width: 1000px) {
    display: none;
  }
`;
